import { useContext } from 'react';
import { AppContext } from '../AppProvider';

const useAuthentication = () => {
    const { signIn, signOut, deleteAccount, signInBySubscription, getUserData, updateUserData } = useContext(AppContext);

    return { signIn, signOut, deleteAccount, signInBySubscription, getUserData, updateUserData };
};

export {
    useAuthentication
};
